// export const SERVER = "http://localhost:8080/api";
export const SERVER = "https://bgchange.ostlive.com/api";
export const allowed_size = 1e7;
